'use strict';
//***********************************************************************************
//***********************************************************************************
import { cn_add } from '../utils/cn_utilities';
import { cn_svg_tool_edition } from './cn_svg_tool_edition';
import { cn_svg_map } from './cn_svg_map';
import { cn_parking_space_handler } from './cn_parking_space_handler';
import { cn_parking_space } from '../model/cn_parking_space';

/**
 * @class cn_svg_tool_parking_space_edition
 * A class to manipulate parking_space
 *
 */
export class cn_svg_tool_parking_space_edition extends cn_svg_tool_edition {
    //***********************************************************************************
    /**
     * Constructor
     * @param {cn_svg_map} map
     */
    constructor(map) {
        super(map);
    }

    //***********************************************************************************
    //**** Selection callback
    //***********************************************************************************
    on_selection_change() {
        const obj = this;
        this._handlers = [];

        //*** We expect the selection to contain only openings */
        var sel = this._controller.get_selection();
        if (sel.length == 0 || sel.some(elt => elt.constructor != cn_parking_space))
            return false;

        this._handlers.push(new cn_parking_space_handler(sel, this._map));
        return true;
    }

    //***********************************************************************************
    //**** Group translation
    //***********************************************************************************
    translate(ev, offset) {
        var selection = this._controller.get_selection();
        for (var i in selection) {
            var elt = selection[i];
            for (var k in elt.vertices)
                elt.vertices[k] = cn_add(elt.vertices[k], offset);
        }
    }

}

